import { apiClient, getActivePvzId, isSupabaseConfigured } from './_shared.js'

export async function getDisputeCounts() {
  if (!isSupabaseConfigured) return { payments: 0, deductions: 0, schedule: 0 }
  const pvzId = localStorage.getItem('wb_active_pvz_id')
  if (!pvzId) return { payments: 0, deductions: 0, schedule: 0 }
  return await apiClient('/analytics/dispute-counts?pvzId=' + pvzId)
}

// 14e: Получить количество выплат сотруднику за последние 24 часа (для уведомлений)
export async function getMyRecentPaymentCount(employeeId) {
  if (!isSupabaseConfigured) return 0
  const data = await apiClient('/payments?employeeId=' + employeeId)
  const since = new Date(Date.now() - 24 * 60 * 60 * 1000)
  return data.filter(p => p.status === 'paid' && new Date(p.created_at || p.period_end) >= since).length
}

// 14f: Получить количество pending пользователей для владельца
export async function getPendingUserCount() {
  const pvzId = getActivePvzId()
  if (!pvzId) return 0
  try {
    const data = await apiClient(`/notifications/counts?pvzId=${pvzId}`)
    return data?.pending_users || 0
  } catch {
    return 0
  }
}

// Оптимизация: один RPC вместо 3-4 отдельных запросов для уведомлений
export async function getAllNotificationCounts(userId, role) {
  const pvzId = getActivePvzId()
  if (!pvzId) return { disputes_payments: 0, disputes_deductions: 0, schedule_pending: 0, pending_users: 0, recent_payments: 0 }
  try {
    const data = await apiClient('/notifications/counts?pvzId=' + pvzId)
    return data || { disputes_payments: 0, disputes_deductions: 0, schedule_pending: 0, pending_users: 0, recent_payments: 0 }
  } catch {
    return { disputes_payments: 0, disputes_deductions: 0, schedule_pending: 0, pending_users: 0, recent_payments: 0 }
  }
}

// Получить кто прочитал конкретное сообщение
export async function getMessageReadBy(messageId) {
  const data = await apiClient(`/chat/messages/${messageId}/read-by`)
  return (data || []).map(r => ({
    userId: r.user_id,
    name: r.name || 'Неизвестный',
    readAt: r.read_at,
  }))
}

// Получить статус доставки: кто прочитал
export async function getMessageReadStatus(messageIds) {
  if (!messageIds.length) return {}

  // Разрезаем на чанки по 100 элементов
  const chunks = []
  const chunkSize = 100
  for (let i = 0; i < messageIds.length; i += chunkSize) {
    chunks.push(messageIds.slice(i, i + chunkSize))
  }

  const results = await Promise.all(
    chunks.map(chunk =>
      apiClient('/chat/messages/read-status', {
        method: 'POST',
        body: JSON.stringify({ messageIds: chunk })
      })
    )
  )

  const data = results.flatMap(res => res || [])

  const result = {}
  data.forEach(r => {
    if (!result[r.message_id]) result[r.message_id] = []
    result[r.message_id].push(r.user_id)
  })

  return result
}


export async function resolveDispute(id, isApproved) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/payments/${id}/resolve`, {
    method: 'PUT',
    body: JSON.stringify({ isApproved })
  })
}

// ─── Notification Center V1A API ────────────────────────────

export async function getNotificationsList() {
  try {
    return await apiClient('/notifications')
  } catch (err) {
    console.error('[Notifications API] Failed to fetch notifications:', err)
    return []
  }
}

export async function getUnreadNotificationsCount() {
  try {
    const data = await apiClient('/notifications/unread-count')
    return data?.count || 0
  } catch (err) {
    console.error('[Notifications API] Failed to fetch unread count:', err)
    return 0
  }
}

export async function markNotificationAsRead(id) {
  try {
    return await apiClient(`/notifications/${id}/read`, { method: 'PUT' })
  } catch (err) {
    console.error('[Notifications API] Failed to mark as read:', err)
    return null
  }
}

export async function markAllNotificationsAsRead() {
  try {
    return await apiClient('/notifications/read-all', { method: 'PUT' })
  } catch (err) {
    console.error('[Notifications API] Failed to mark all as read:', err)
    return null
  }
}
